import type { Component } from 'vue'
import type { UseModalOptions } from 'vue-final-modal'
import { AModal } from '#components'
import { useModal as useModalBase } from 'vue-final-modal'

export function useModal<
  TTarget extends Component,
  TModal extends Component = typeof AModal,
>(config: {
  component: () => TTarget
  modalAttrs?: UseModalOptions<typeof AModal>['attrs']
  modalComponent?: () => TModal
  modalSlots?: UseModalOptions<typeof AModal>['slots']
}) {
  return useModalBase({
    attrs: config.modalAttrs,
    component: AModal,
    slots: {
      default: config.component,
      ...config.modalSlots,
    },
  })
}
